import React from 'react';
import "../../styles/principals/aboutme.css";

const AboutMe = () => {
  return (
    <div className="about-container">
      <div className="about-header">
        <h1>Acerca de Noi</h1>
      </div>      
      <div className="about-content">
        <div className="about-image">
        <img 
          src="https://firebasestorage.googleapis.com/v0/b/noi-donostia-16e2f.appspot.com/o/Servicios%2FManicura%2FManciura_gun.jpg?alt=media&token=3377923f-9ed1-400f-836d-c403a1743757" 
          alt="Imagen de perfil" 
        />
        </div>
        <div className="about-text">
          <p>
            Nuestra historia comenzó en las hermosas calles de San Sebastián, donde la inspiración está en cada esquina. 
            Por lo que quisimos transmitir ese espíritu a través de nuestro trabajo. Nos encanta marcar tendencia, pero también celebramos la individualidad de cada uno de nuestros clientes.  
          </p>
          <p>
            Noi nace fruto de la velocidad de la vida actual, donde el tiempo es un recurso valioso. Nos dedicamos a brindar un servicio de cuidado estético a domicilio. 
            Personalizado y directamente a tu puerta.
          </p>
          <p>
            En Noi Donostia, celebramos la belleza en todas sus formas. Somos una comunidad apasionada por el cuidado personal y el bienestar. 
            Creemos que la belleza es más que una apariencia externa; es un reflejo de cómo nos sentimos por dentro. Por eso, nos esforzamos en ofrecer productos y servicios de alta calidad.
          </p>
          <p>
            Nuestro compromiso es ofrecer la máxima profesionalidad en cada sesión. Con nosotros podrás lucir una manicura, pedicura y una piel radiante, 
            disfrutando a su vez de un momento relajado.
            Cada servicio está diseñado para adaptarse a tus horarios y preferencias, brindándote la oportunidad de cuidarte sin tener que sacrificar tu tiempo y comodidad.
            Nuestra pasión radica en resaltar la belleza natural de cada persona, y así disfruten de su mejor versión. <br /><br/>
            En Noi, tu satisfacción es nuestra prioridad.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutMe;